import type { TenantMembershipDto } from "../types";

/**
 * Perfis atendidos pelo Apogeu App.
 * A API modela o aluno como `Member` (tabela `members`), então o papel de
 * acesso no contexto do CT usa o slug `member`; `coach` representa o professor.
 */
export type MobileRole = "member" | "coach";
export type MobileAccess = MobileRole | "denied";

const MOBILE_ROLES = new Set<string>(["member", "coach"]);

const ROLE_LABELS: Record<MobileRole, string> = {
  member: "Aluno",
  coach: "Professor",
};

/**
 * Allowlist fail-safe: somente alunos (`member`) e professores (`coach`) entram no app.
 * owner/admin/staff e qualquer role desconhecida (ou ausente) são negados.
 */
export function resolveMobileAccess(roleSlug: string | null): MobileAccess {
  if (!roleSlug) return "denied";
  const role = roleSlug.toLowerCase();
  return MOBILE_ROLES.has(role) ? (role as MobileRole) : "denied";
}

export function isMobileRole(roleSlug: string | null): roleSlug is MobileRole {
  return resolveMobileAccess(roleSlug) !== "denied";
}

export function roleLabel(role: MobileRole): string {
  return ROLE_LABELS[role];
}

/** CTs em que o usuário pode entrar pelo app (ignora vínculos de gestão). */
export function allowedTenants(tenants: TenantMembershipDto[]): TenantMembershipDto[] {
  return tenants.filter(tenant => resolveMobileAccess(tenant.roleSlug) !== "denied");
}
